import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3jx8e2jgty: FaireBrandEntity = {
  token: "b_3jx8e2jgty",
  type: "brand",
  name: "Riley & Rett",
  avatarUrl:
    "https://cdn.faire.com/fastly/3ec1db5f997d968f137d7acfe90d499cae0a39353ff2525af91410e7a100ee80.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/f6b5af53f45e057c1c34318bb1ceae659cff46c759725e4230205bccc23c716e.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/3ec1db5f997d968f137d7acfe90d499cae0a39353ff2525af91410e7a100ee80.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f6b5af53f45e057c1c34318bb1ceae659cff46c759725e4230205bccc23c716e.jpeg",
  location: "Rhome, TX, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 8,
  isInsider: true,
  description:
    "Riley & Rett is a brand that celebrates siblings, sunshine, and clothing that makes you smile! Here you will find clothing that is stylish enough to wear out and about and comfy enough to wear to snooze. We carry boys, girls, baby and kids sizes so everyone can match!",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:15.590Z",
    importedBy: "entity-db-cli",
  },
};
